'use strict';

var _ = require('lodash');
var SaveScenarioDirective = function SaveScenarioDirective(scenarioKeyboardSaveService) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/save-scenario.html'),
    controller: 'ScenarioController',
    scope: {
      scenarioPermission: '@?',
      disabledNewScenario: '=?',
      disabledExistingScenario: '=?'
    },
    link: function link($scope, element) {
      element.find('.gdpr-popover').popover();
      $scope.$on('scenarios:loaded', $scope.loadScenarioList);
      $scope.$on('user-overrides:save', function (evt, saveData, saveToProd) {
        $scope.overridesData = saveData.data;
        $scope.overridesGridId = saveData.gridId;
        $scope.selectedRow = saveData.selectedRows;
        $scope.userAction = saveData.userAction;
        $scope.reoptSaveData = saveData.reoptSaveData;
        $scope.reoptPreviewData = saveData.reoptPreviewData;
        var selectedScenario = saveData.scenarioName || $scope.getSelectedScenarioName();
        if (selectedScenario) {
          $scope.saveOverridesToScenario(selectedScenario);
        } else if (saveToProd) {
          scenarioKeyboardSaveService.attempToSave(saveData).then(function (saveData) {
            $scope.overridesData = saveData.data;
            $scope.overridesGridId = saveData.gridId;
            $scope.selectedRow = saveData.selectedRows;
            $scope.userAction = saveData.userAction;
            $scope.reoptSaveData = saveData.reoptSaveData;
            $scope.reoptPreviewData = saveData.reoptPreviewData;
            $scope.saveScenario();
          });
        } else {
          element.modal('show');
        }
      });
    }
  };
};
SaveScenarioDirective.$inject = ['ScenarioKeyboardSaveService'];
module.exports = SaveScenarioDirective;